<template>
  <hr class="divider" :class="size" :style="styles" />
</template>

<script>
export default {
  name: 'Divider',
  props: {
    size: {
      type: String,
      default: 'md',
    },
    pattern: {
      type: String,
      default: 'lined',
    },
    color: {
      type: String,
      default: 'black',
    },
    background: {
      type: String,
      default: 'white',
    },
  },
  computed: {
    styles() {
      return this.pattern === 'lined'
        ? { backgroundColor: this.color }
        : this.pattern === 'dashed'
          ? {
              backgroundImage: `repeating-linear-gradient(
              90deg,
              ${this.color} 0,
              ${this.color} 5px,
              ${this.background} 5px,
              ${this.background} 10px
            )`,
            }
          : {};
    },
  },
};
</script>

<style scoped lang="scss">
.divider {
  display: block;
  height: 0.02em;
  width: 100%;
  background-color: black;
  border: none;
  margin: 0px;
  &.sm {
    height: 0.01em;
  }
  &.lg {
    height: 0.03em;
  }
}
</style>
